import actionTypes from '../constants/action-types';

const clearScrollTargetPath = () => ({
  type: actionTypes.CLEAR_SCROLL_TARGET_PATH,
});

export default clearScrollTargetPath;
